// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для компонента TaskManager с использованием Ant Design */

.task-manager-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: space-evenly;
  }
  .ant-row.css-dev-only-do-not-override-11y2uj8{
    display: flex;
    justify-content: center;
  }
  /* Стили для карточек задач */
  .task-card {
    transition: all 0.3s ease;
    margin-bottom: 16px !important;
    border-radius: 8px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  .task-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-3px);
  }
  
  .task-card.completed {
    background-color: rgba(240, 255, 240, 0.5);
  }
  
  .task-card .ant-card-meta-title {
    margin-bottom: 12px !important;
    font-size: 16px !important;
  }
  
  .task-card .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.65) !important;
    white-space: pre-line !important;
  }
  
  /* Стили для карточки редактирования */
  .task-card.editing {
    background-color: #f9f9f9;
    border: 1px solid #d9d9d9;
  }
  
  .task-card.editing .ant-form-item-label > label {
    font-weight: 500;
  }
  
  /* Стили для ленты статуса */
  .ant-ribbon {
    font-size: 12px !important;
    font-weight: 500 !important;
    height: 22px !important;
    line-height: 22px !important;
  }
  
  .ant-ribbon.ant-ribbon-placement-end {
    right: -8px !important;
    margin-right: 8px !important;
  }
  
  /* Стили для контейнера карточек */
  .tasks-card {
    min-height: 300px;
    background-color: #fff !important;
    border-radius: 8px !important;
  }
  
  .tasks-card .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
    padding: 0 16px !important;
  }
  
  .tasks-card .ant-card-head-title {
    padding: 12px 0 !important;
  }
  
  .tasks-card .ant-card-body {
    padding: 16px !important;
  }
  
  /* Стили для кнопок действий */
  .task-card .ant-card-actions {
    background-color: #f9f9f9;
    border-top: 1px solid #f0f0f0;
  }
  
  .task-card .ant-card-actions > li {
    margin: 6px 0;
  }
  
  .task-card .ant-btn-text {
    color: #595959;
  }
  
  .task-card .ant-btn-text:hover {
    color: #1abc9c;
    background-color: rgba(26, 188, 156, 0.1);
  }
  
  .task-card .ant-btn-text.ant-btn-dangerous:hover {
    color: #ff4d4f;
    background-color: rgba(255, 77, 79, 0.1);
  }
  
  /* Стили для индикатора загрузки */
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 0;
  }
  
  .loading-text {
    margin-top: 16px;
    color: #8c8c8c;
  }
  
  /* Стили для пустого состояния */
  .ant-empty {
    margin: 32px 0;
  }
  
  .ant-empty-description {
    color: #8c8c8c;
  }
  
  /* Стили для формы создания новой задачи */
  .tasks-card .ant-form-item-label > label {
    color: #262626;
  }
  
  .tasks-card .ant-form-item {
    margin-bottom: 16px;
  }
  
  .tasks-card .ant-input:focus,
  .tasks-card .ant-input-focused,
  .tasks-card .ant-input:hover {
    border-color: #1abc9c;
    box-shadow: 0 0 0 2px rgba(26, 188, 156, 0.2);
  }
  
  /* Адаптивность для мобильных устройств */
  @media screen and (max-width: 768px) {
    .task-manager-container {
      padding: 15px;
    }
    
    .task-card .ant-card-actions > li {
      margin: 4px 0;
    }
    
    .task-card .ant-btn-text {
      padding: 2px 8px;
      font-size: 12px;
    }
    
    .task-card .ant-card-actions > li > span {
      padding: 0;
    }
  }
  
  /* Стили для модальных окон подтверждения */
  .ant-modal-confirm .ant-modal-confirm-btns {
    margin-top: 24px;
  }
  
  .ant-modal-confirm .ant-modal-confirm-title {
    font-weight: 600;
  }
  
  /* Улучшение стилей для раскрывающегося текста */
  .ant-typography-expand,
  .ant-typography-expand:hover {
    color: #1abc9c;
  }
  
  /* Стили для цветов ленты */
  .ant-ribbon-green {
    background-color: #52c41a !important;
  }
  
  .ant-ribbon-blue {
    background-color: #1890ff !important;
  }
  
  /* Стили для заголовков */
  h2.ant-typography {
    color: #262626;
    margin-bottom: 24px;
  }
  
  h4.ant-typography {
    color: #262626;
    margin: 0 !important;
  }

  button.ant-btn.css-dev-only-do-not-override-11y2uj8.ant-btn-text.ant-btn-color-default.ant-btn-variant-text{
    background-color: #f1f1f1 !important;
    margin-inline-end: 70px;
  }

  button.ant-btn.css-dev-only-do-not-override-11y2uj8.ant-btn-text.ant-btn-dangerous.ant-btn-color-dangerous.ant-btn-variant-text{
    background-color: #f1f1f1 !important;
  }`, "",{"version":3,"sources":["webpack://./src/styles/TaskAntd.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA,6BAA6B;EAC7B;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;IAC7B,wCAAwC;EAC1C;;EAEA;IACE,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA,sCAAsC;EACtC;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,yCAAyC;EAC3C;;EAEA;IACE,cAAc;IACd,wCAAwC;EAC1C;;EAEA,kCAAkC;EAClC;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,gCAAgC;EAChC;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,0CAA0C;EAC1C;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA,yCAAyC;EACzC;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;;IAEE,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA,yBAAyB;EACzB;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;EACtC","sourcesContent":["/* Стили для компонента TaskManager с использованием Ant Design */\r\n\r\n.task-manager-container {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    justify-content: space-evenly;\r\n  }\r\n  .ant-row.css-dev-only-do-not-override-11y2uj8{\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  /* Стили для карточек задач */\r\n  .task-card {\r\n    transition: all 0.3s ease;\r\n    margin-bottom: 16px !important;\r\n    border-radius: 8px !important;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .task-card:hover {\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    transform: translateY(-3px);\r\n  }\r\n  \r\n  .task-card.completed {\r\n    background-color: rgba(240, 255, 240, 0.5);\r\n  }\r\n  \r\n  .task-card .ant-card-meta-title {\r\n    margin-bottom: 12px !important;\r\n    font-size: 16px !important;\r\n  }\r\n  \r\n  .task-card .ant-card-meta-description {\r\n    color: rgba(0, 0, 0, 0.65) !important;\r\n    white-space: pre-line !important;\r\n  }\r\n  \r\n  /* Стили для карточки редактирования */\r\n  .task-card.editing {\r\n    background-color: #f9f9f9;\r\n    border: 1px solid #d9d9d9;\r\n  }\r\n  \r\n  .task-card.editing .ant-form-item-label > label {\r\n    font-weight: 500;\r\n  }\r\n  \r\n  /* Стили для ленты статуса */\r\n  .ant-ribbon {\r\n    font-size: 12px !important;\r\n    font-weight: 500 !important;\r\n    height: 22px !important;\r\n    line-height: 22px !important;\r\n  }\r\n  \r\n  .ant-ribbon.ant-ribbon-placement-end {\r\n    right: -8px !important;\r\n    margin-right: 8px !important;\r\n  }\r\n  \r\n  /* Стили для контейнера карточек */\r\n  .tasks-card {\r\n    min-height: 300px;\r\n    background-color: #fff !important;\r\n    border-radius: 8px !important;\r\n  }\r\n  \r\n  .tasks-card .ant-card-head {\r\n    border-bottom: 1px solid #f0f0f0;\r\n    padding: 0 16px !important;\r\n  }\r\n  \r\n  .tasks-card .ant-card-head-title {\r\n    padding: 12px 0 !important;\r\n  }\r\n  \r\n  .tasks-card .ant-card-body {\r\n    padding: 16px !important;\r\n  }\r\n  \r\n  /* Стили для кнопок действий */\r\n  .task-card .ant-card-actions {\r\n    background-color: #f9f9f9;\r\n    border-top: 1px solid #f0f0f0;\r\n  }\r\n  \r\n  .task-card .ant-card-actions > li {\r\n    margin: 6px 0;\r\n  }\r\n  \r\n  .task-card .ant-btn-text {\r\n    color: #595959;\r\n  }\r\n  \r\n  .task-card .ant-btn-text:hover {\r\n    color: #1abc9c;\r\n    background-color: rgba(26, 188, 156, 0.1);\r\n  }\r\n  \r\n  .task-card .ant-btn-text.ant-btn-dangerous:hover {\r\n    color: #ff4d4f;\r\n    background-color: rgba(255, 77, 79, 0.1);\r\n  }\r\n  \r\n  /* Стили для индикатора загрузки */\r\n  .loading-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 50px 0;\r\n  }\r\n  \r\n  .loading-text {\r\n    margin-top: 16px;\r\n    color: #8c8c8c;\r\n  }\r\n  \r\n  /* Стили для пустого состояния */\r\n  .ant-empty {\r\n    margin: 32px 0;\r\n  }\r\n  \r\n  .ant-empty-description {\r\n    color: #8c8c8c;\r\n  }\r\n  \r\n  /* Стили для формы создания новой задачи */\r\n  .tasks-card .ant-form-item-label > label {\r\n    color: #262626;\r\n  }\r\n  \r\n  .tasks-card .ant-form-item {\r\n    margin-bottom: 16px;\r\n  }\r\n  \r\n  .tasks-card .ant-input:focus,\r\n  .tasks-card .ant-input-focused,\r\n  .tasks-card .ant-input:hover {\r\n    border-color: #1abc9c;\r\n    box-shadow: 0 0 0 2px rgba(26, 188, 156, 0.2);\r\n  }\r\n  \r\n  /* Адаптивность для мобильных устройств */\r\n  @media screen and (max-width: 768px) {\r\n    .task-manager-container {\r\n      padding: 15px;\r\n    }\r\n    \r\n    .task-card .ant-card-actions > li {\r\n      margin: 4px 0;\r\n    }\r\n    \r\n    .task-card .ant-btn-text {\r\n      padding: 2px 8px;\r\n      font-size: 12px;\r\n    }\r\n    \r\n    .task-card .ant-card-actions > li > span {\r\n      padding: 0;\r\n    }\r\n  }\r\n  \r\n  /* Стили для модальных окон подтверждения */\r\n  .ant-modal-confirm .ant-modal-confirm-btns {\r\n    margin-top: 24px;\r\n  }\r\n  \r\n  .ant-modal-confirm .ant-modal-confirm-title {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  /* Улучшение стилей для раскрывающегося текста */\r\n  .ant-typography-expand,\r\n  .ant-typography-expand:hover {\r\n    color: #1abc9c;\r\n  }\r\n  \r\n  /* Стили для цветов ленты */\r\n  .ant-ribbon-green {\r\n    background-color: #52c41a !important;\r\n  }\r\n  \r\n  .ant-ribbon-blue {\r\n    background-color: #1890ff !important;\r\n  }\r\n  \r\n  /* Стили для заголовков */\r\n  h2.ant-typography {\r\n    color: #262626;\r\n    margin-bottom: 24px;\r\n  }\r\n  \r\n  h4.ant-typography {\r\n    color: #262626;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  button.ant-btn.css-dev-only-do-not-override-11y2uj8.ant-btn-text.ant-btn-color-default.ant-btn-variant-text{\r\n    background-color: #f1f1f1 !important;\r\n    margin-inline-end: 70px;\r\n  }\r\n\r\n  button.ant-btn.css-dev-only-do-not-override-11y2uj8.ant-btn-text.ant-btn-dangerous.ant-btn-color-dangerous.ant-btn-variant-text{\r\n    background-color: #f1f1f1 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
